<template>
  <div>
    <ValidationProvider v-slot='{ errors, passed, failed }' :rules="{ 'required': true}" slim>
      <div :class="[failed && 'lib__field--error', passed && 'lib__field--valid']" class='lib__field'>
        <div class='lib__tiles lib__tiles--inline'>
          <TileRadio
            v-model='value.hasBattery'
            :item='true'
            :label="$t('common.yes')"
            group='battery'>
            <template v-slot:picture>
              <i class='fas fa-check'></i>
            </template>
          </TileRadio>
          <TileRadio
            v-model='value.hasBattery'
            :item='false'
            :label="$t('common.no')"
            group='battery'>
            <template v-slot:picture>
              <i class='fas fa-times'></i>
            </template>
          </TileRadio>
        </div>
        <error-message :error='errors[0]'></error-message>
      </div>
    </ValidationProvider>

    <template v-if='value.hasBattery === true'>
      <template v-for='(battery, index) in value.batteries'>
        <label class='lib__field__label lib__no-padding'>
          {{ $t('prosumerDeclaration.battery.battery') }} {{ index + 1 }}
          <span class='lib__tooltips' @click='batteryModalOpen = true'>
          <span><i class='fas fa-info-circle lib__clickable-tooltips'></i></span>
          </span>
        </label>
        <div class='row'>
          <div class='col-xs-4'>
            <text-box v-model='value.batteries[index].brand' :placeholder="$t('prosumerDeclaration.battery.brand')"
                      required />
          </div>
          <div class='col-xs-4'>
            <text-box v-model='value.batteries[index].type' :placeholder="$t('prosumerDeclaration.battery.type')"
                      required />
          </div>
          <div class='col-xs-3'>
            <number-box v-model='value.batteries[index].capacity'
                        :placeholder="$t('prosumerDeclaration.battery.capacity')"
                        required />
          </div>
          <div v-if='value.batteries.length > 1' class='col-xs-1'>
            <button class='lib__btn-action' type='button' @click.prevent='removeBattery(index)'>
                  <span class='lib__badge lib__badge--primary'>
                    <i class='fas fa-trash'></i>
                  </span>
            </button>
          </div>
        </div>
      </template>
      <button v-if='value.batteries.length < 7' class='lib__btn-action' type='button' @click.prevent='addBattery'>
              <span class='lib__badge lib__badge--primary'>
                <i class='fas fa-plus'></i>
              </span>
        <span class='lib__btn-action__label'>{{ $t('prosumerDeclaration.battery.addBattery') }}</span>
      </button>
    </template>
    <ModalDialog :closeable="$t('common.close')" :open.sync='batteryModalOpen'>
      <h3>{{ $t('prosumerDeclaration.battery.modal.battery.title') }}</h3>
      <p v-html="$t('prosumerDeclaration.battery.modal.battery.text')" />
    </ModalDialog>
  </div>
</template>

<script lang='ts'>
import Component from 'vue-class-component'
import { Prop, Vue, Watch } from 'vue-property-decorator'
import { BatteryInformation } from '@/models/prosumer-declaration/prosumer-declaration'

@Component({
  name: 'battery-information-component'
})
export default class BatteryInformationComponent extends Vue {
  @Prop({ type: Object, required: true }) public readonly value!: BatteryInformation

  public batteryModalOpen: boolean = false

  public addBattery() {
    this.value.batteries.push({ brand: null, type: null, capacity: null })
  }

  public removeBattery(index: number) {
    this.value.batteries.splice(index, 1)
  }

  @Watch('value.hasBattery', { deep: true })
  public onHasBatteryChanged(newVal: boolean) {
    if (newVal && this.value.batteries.length === 0) {
      this.addBattery()
    }

    if (!newVal && this.value.batteries.length !== 0) {
      this.value.batteries = []
    }
  }
}
</script>
